import { Box, Link, Typography } from '@mui/material';

type Props = {
    onAccept: () => void;
    onDecline: () => void;
};

const buttonStyle = {
    background: 'none',
    border: '1px solid rgba(255,255,255,0.45)',
    color: '#f0f0f0',
    padding: '7px 20px',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: 14,
    fontFamily: 'inherit'
} as const;

/** Bottom consent bar matching legacy platform styling and copy. */
export function CookieConsentBanner({ onAccept, onDecline }: Props) {
    return (
        <Box
            className="cookie-notification"
            role="dialog"
            aria-live="polite"
            aria-label="Cookie consent"
            sx={{
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                zIndex: 2147483640,
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                flexWrap: 'wrap',
                background: '#1a1a1a',
                color: '#f0f0f0',
                boxShadow: '0 -2px 16px rgba(0,0,0,.5)',
                px: 2.5,
                py: 1.75,
                fontFamily: "-apple-system,BlinkMacSystemFont,'Segoe UI',Helvetica,sans-serif",
                fontSize: 15,
                lineHeight: 1.5,
                textAlign: 'left'
            }}
        >
            <Typography
                component="p"
                sx={{
                    flex: 1,
                    m: 0,
                    minWidth: 220,
                    color: 'inherit',
                    fontSize: 'inherit',
                    lineHeight: 'inherit'
                }}
            >
                This platform uses cookies from Google (analytics) and Zendesk (live support chat).
                Declining will disable the live chat widget.{' '}
                <Link
                    href="/Public/cookies.asp"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ color: '#aaa', whiteSpace: 'nowrap' }}
                >
                    Cookie policy
                </Link>
            </Typography>
            <Box sx={{ display: 'flex', gap: 1, flexShrink: 0 }}>
                <Box component="button" type="button" onClick={onDecline} sx={buttonStyle}>
                    Decline
                </Box>
                <Box component="button" type="button" onClick={onAccept} sx={buttonStyle}>
                    Accept cookies
                </Box>
            </Box>
        </Box>
    );
}
